import {Injectable} from '@angular/core';
import {AngularFirestore, DocumentChangeAction} from '@angular/fire/compat/firestore';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SiteLogsService {

  constructor (private db: AngularFirestore) { }

  loadSiteLogs (): Observable<any[]> {
    // 1. Constrói a query (Observable)
    const query = this.db.collection<any>('sbccv_site_logs', ref => ref
      .orderBy('date', 'desc')
    ).snapshotChanges();

    // 2. Mapeia as ações do snapshot para um Observable<any[]>
    return query.pipe(
      map((actions: DocumentChangeAction<any>[]): any[] => {
        // 3. Mapeia as ações do snapshot para um array de dados
        const array: any[] = actions.map(action => {
          const docData = action.payload.doc.data() as any;
          return {
            ...docData,
            id: action.payload.doc.id,
            date: this.toDate(docData.date),
          };
        });
        return array;
      })
    );
  }

  toDate (value: any): Date | null {
    return (value && typeof value.toDate === 'function') ? value.toDate() : null;
  };

}

